import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=468d97bb&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('468d97bb')) {
      api.createRecord('468d97bb', component.options)
    } else {
      api.reload('468d97bb', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=468d97bb&", function () {
      api.rerender('468d97bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jcP8DZ4yl6zm/JS/comp/ImgFallback.vue"
export default component.exports